/* import __COLOCATED_TEMPLATE__ from './search-results-item-service-list.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

class SearchResultsItemServiceList extends Component {
  @tracked invisibleElements = new Set();
  @tracked observer = null;

  get hiddenServiceCount() {
    return this.invisibleElements.size;
  }

  willDestroy() {
    super.willDestroy();

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  @action
  setObserver(root) {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          this.invisibleElements.delete(target);
        } else {
          this.invisibleElements.add(target);
        }
      });

      this.invisibleElements = this.invisibleElements;
    }, { root, threshold: [0, 1] });
  }

  @action
  cleanup(element) {
    if (!this.isDestroying) {
      this.invisibleElements.delete(element);
      this.invisibleElements = this.invisibleElements;
    }
  }
}

export default SearchResultsItemServiceList;
